import cx from 'clsx';
import React from 'react';

import { ReactComponent as LogoIcon } from '@assets/svg/logo-icon.svg';
import { ReactComponent as LogoName } from '@assets/svg/logo-name.svg';

import style from './style.module.scss';

interface IProps {
  sidebarResponse: boolean;
  handleClick: () => void;
}

const SidebarLogo: React.FC<IProps> = ({ sidebarResponse, handleClick }) => {
  return (
    <div
      id="tourStep-1"
      className={cx(style.sidebarLogoContainer, {
        [style.hiddenSidebarLogoContainer]: sidebarResponse,
      })}
      onClick={handleClick}
    >
      <div className={style.sidebarLogoAnimationContainer}>
        <LogoIcon className={style.logoIcon} />
        <div className={style.sidebarSmallTextLogoContainer}>
          <LogoName />
        </div>
        <div className={style.sidebarTextLogoContainer}>
          <LogoName />
        </div>
      </div>
    </div>
  );
};

export default SidebarLogo;
